"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = storeDevToolInit;
const isEqual = (a, b) => {
  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) {
    return a === b;
  }
  if (Object.keys(a).length !== Object.keys(b).length) {
    return false;
  }
  return JSON.stringify(a) === JSON.stringify(b);
};
function storeDevToolInit(storeInstance) {
  let storeInitialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let serviceName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'xhh';
  let place = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'page';
  let cache = {};
  let unsubscribe;
  if (!window.store) {
    window.store = {};
  }
  if (!window.store[serviceName]) {
    window.store[serviceName] = {};
  }
  const storeHandler = function () {
    let mask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let includeUnchangedFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const search = mask.toLowerCase();
    const fields = Object.entries(storeInstance.getState()).filter(_ref => {
      let [key] = _ref;
      return key.toLowerCase().includes(search);
    });
    if (includeUnchangedFields) {
      return Object.fromEntries(fields);
    }
    return Object.fromEntries(fields.filter(_ref2 => {
      let [key, value] = _ref2;
      return !isEqual(storeInitialState[key], value);
    }));
  };
  storeHandler.subscribe = function () {
    let mask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let includeUnchangedFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    function compare() {
      const state = window.store[serviceName][place](mask, includeUnchangedFields);
      const result = Object.fromEntries(Object.entries(state).filter(_ref3 => {
        let [key, value] = _ref3;
        return value !== cache[key];
      }));
      if (Object.keys(result).length > 0) {
        // eslint-disable-next-line no-console
        console.log(`Service name: ${serviceName}, Place: ${place}`, result);
      }
      cache = state;
    }
    if (unsubscribe) {
      unsubscribe();
    }
    unsubscribe = storeInstance.subscribe(compare);
    compare();
    window.localStorage.setItem(`DEV_STORE_SUBSCRIBE_${serviceName}_${place}`, JSON.stringify({
      mask,
      includeUnchangedFields
    }));
  };
  storeHandler.unsubscribe = () => {
    if (unsubscribe) {
      unsubscribe();
    }
    window.localStorage.removeItem(`DEV_STORE_SUBSCRIBE_${serviceName}_${place}`);
  };
  window.store[serviceName][place] = storeHandler;
  const toSubscribe = window.localStorage.getItem(`DEV_STORE_SUBSCRIBE_${serviceName}_${place}`);
  if (toSubscribe) {
    const {
      mask,
      includeUnchangedFields
    } = JSON.parse(toSubscribe);
    window.store[serviceName][place].subscribe(mask, includeUnchangedFields);
  }
}
//# sourceMappingURL=index.js.map